import { render, staticRenderFns } from "./VipServiceGetView.vue?vue&type=template&id=a36d5f1c&scoped=true"
import script from "./VipServiceGetView.vue?vue&type=script&lang=js"
export * from "./VipServiceGetView.vue?vue&type=script&lang=js"
import style0 from "./VipServiceGetView.vue?vue&type=style&index=0&id=a36d5f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36d5f1c",
  null
  
)

export default component.exports